import React from 'react';

const VerTextoDialog = ({ dialogVerTexto, onClose, onCopiar }) => {
  if (!dialogVerTexto.isOpen) return null;

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>📄 {dialogVerTexto.nomeArquivo}</h3>
          <button className="btn-fechar" onClick={onClose}>✖</button>
        </div>
        <div className="dialog-body">
          <textarea className="dialog-textarea" value={dialogVerTexto.conteudo} readOnly rows={20} />
        </div>
        <div className="dialog-footer">
          <button className="btn-copiar" onClick={onCopiar}>📋 COPIAR</button>
        </div>
      </div>
    </div>
  );
};

export default VerTextoDialog;
